export var preferenceBasedLongDateFormats = {
    0: {
        L: 'MM/DD/YYYY',
        LX: 'MM/DD',
        llx: 'MMM DD',
        l: 'M/D/YYYY',
        CL: 'MMMM D, YYYY',
        CCL: 'dddd, MMMM D, YYYY'
    },
    1: {
        L: 'MM.DD.YYYY',
        l: 'M.D.YYYY',
        LX: 'MM.DD',
        llx: 'MMM DD',
        CL: 'MMMM D, YYYY',
        CCL: 'dddd, MMMM D, YYYY'
    },
    2: {
        L: 'MM-DD-YYYY',
        l: 'M-D-YYYY',
        LX: 'MM-DD',
        llx: 'MMM DD',
        CL: 'MMMM D, YYYY',
        CCL: 'dddd, MMMM D, YYYY'
    },
    3: {
        L: 'DD/MM/YYYY',
        l: 'D/M/YYYY',
        LX: 'DD/MM',
        llx: 'DD MMM',
        CL: 'D MMMM, YYYY',
        CCL: 'dddd, D MMMM, YYYY'
    },
    4: {
        L: 'DD.MM.YYYY',
        l: 'D.M.YYYY',
        LX: 'DD.MM',
        llx: 'DD MMM',
        CL: 'D MMMM, YYYY',
        CCL: 'dddd, D MMMM, YYYY'
    },
    5: {
        L: 'DD-MM-YYYY',
        l: 'D-M-YYYY',
        LX: 'DD-MM',
        llx: 'DD MMM',
        CL: 'D MMMM, YYYY',
        CCL: 'dddd, D MMMM, YYYY'
    },
    6: {
        L: 'YYYY/MM/DD',
        l: 'YYYY/M/D',
        LX: 'MM/DD',
        llx: 'MMM DD',
        CL: 'YYYY, MMMM D',
        CCL: 'dddd, YYYY, MMMM D'
    },
    7: {
        L: 'YYYY.MM.DD',
        l: 'YYYY.M.D',
        LX: 'MM.DD',
        llx: 'MMM DD',
        CL: 'YYYY, MMMM D',
        CCL: 'dddd, YYYY, MMMM D'
    },
    8: {
        L: 'YYYY-MM-DD',
        l: 'YYYY-M-D',
        LX: 'MM-DD',
        llx: 'MMM DD',
        CL: 'YYYY, MMMM D',
        CCL: 'dddd, YYYY, MMMM D'
    }
};
